export default __webpack_public_path__ + "static/Onsite-79e4c6ef0484852c3ece40885b230389.webp";